import { Identity } from "@pdfking/tfunc"

import { getter } from "./getter"
import { is_mapping } from "./is_mapping"
import { map } from "./map"
import { ordered_object } from "./ordered_object"
import { scan } from "./scan"

const array_assigner = (result, grouper, k, v) => {
  if (!result[grouper]) {
    result[grouper] = []
  }
  result[grouper].push(v)
}

const mapping_assigner = (result, grouper, k, v) => {
  if (!result[grouper]) {
    result[grouper] = ordered_object()
  }
  result[grouper][k] = v
}

export const group_by = (iterable, f: any = Identity, merger = null) => {
  const assigner = is_mapping(iterable) ? mapping_assigner : array_assigner
  const grouping = getter(f)
  const result = ordered_object()

  // @ts-expect-error - grouping may accept 2 args
  scan((v, k) => assigner(result, grouping(v, k), k, v), iterable)

  if (merger) {
    return map(merger, result)
  }

  return result
}
